var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"es-loading",style:(_vm._f("transRpxStyle")([(_vm.style)]))},_vm._l(((12)),function(item,index){return _c('div',{key:item.item,staticClass:"es-loading__spinner"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }